import { render, staticRenderFns } from "./DosMediaU5.vue?vue&type=template&id=50b808e6&scoped=true&"
import script from "./DosMediaU5.vue?vue&type=script&lang=js&"
export * from "./DosMediaU5.vue?vue&type=script&lang=js&"
import style0 from "./DosMediaU5.vue?vue&type=style&index=0&id=50b808e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b808e6",
  null
  
)

export default component.exports